<template>
  <div id="goodsPurchaseReturn">
    <div class="invoicingHead" style="height: 110px;">
      <div class="row">
        <el-button
          size="small"
          type="primary"
          @click="jumpTT('/invoicingFather/addGoodsPurchaseReturn')"
          >新增进货退货单</el-button
        >
        <div class="row" style>
          <el-input
            size="small"
            style="margin-left:10px"
            placeholder="输入单号/仓库名称"
            v-model="synthesisSearch"
          ></el-input>
          <el-button
            size="small"
            style="margin-left:10px"
            @click="search"
            type="primary"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="searchGroup">
        <el-select
          size="small"
          v-model="synthesisOrderType"
          placeholder="排序"
          @change="synthesisOrderTypeChange"
        >
          <el-option
            v-for="item in synthesisOrderTypeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- <el-date-picker type="dates" v-model="dataTime" placeholder="选择业务日期" @change="dataTimeChoose" value-format="yyyy-MM-dd"></el-date-picker> -->
        <el-date-picker
          v-model="dataTime"
          :clearable="false"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataTimeChoose"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <!-- <el-select size="small" v-model="repository" shopStore="入库仓库">
              <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
            </el-select> -->
        <el-select size="small" v-model="shopWorkerUserId" placeholder="经手人">
          <el-option
            v-for="item in handlerList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
        <!-- <el-select size="small" v-model="outStorageStatus" placeholder="入库状态">
              <el-option v-for="item in outStorageStatusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select> -->
        <!-- <el-select size="small" v-model="value" placeholder="单据上传状态">
              <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select> -->
        <el-select size="small" v-model="isDestroy" placeholder="显示作废">
          <el-option
            v-for="item in isDestroyList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          style="margin-left:10px"
          @click="deleteSearch"
          type="primary"
          >清除</el-button
        >
        <el-button
          size="small"
          style="margin-left:10px"
          @click="search"
          type="primary"
          >完成</el-button
        >
      </div>
    </div>
    <div class="content">
      <div class="refundMoney">
        <div class="totalMoney">合计金额（元）</div>
        <div>{{ totalRefoundMoney.toFixed(2) }}</div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        element-loading-text="数据正在加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          align="center"
          prop="goodsName"
          label="退货商品"
          width="180"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="repositoryName"
          label="出库仓库"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="supplierName"
          label="供应商"
          width="180"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="orderCode"
          label="单号"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="accountRefundPayable"
          label="金额"
        >
          <template slot-scope="scope">
            ￥{{ scope.row.accountRefundPayable }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="businessTime"
          label="业务日期"
        ></el-table-column>
        <el-table-column align="center" prop="outStorageStatus" label="状态">
          <template slot-scope="scope">
            <div
              v-if="scope.row.outStorageStatus == 0"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #AFAFAF;margin:auto;color:#AFAFAF;font-size:10px;"
            >
              未出库
            </div>
            <div
              v-if="scope.row.outStorageStatus == 1"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #FDB99E;margin:auto;color:#FDB99E;font-size:10px;"
            >
              已出库
            </div>
            <div
              v-if="scope.row.outStorageStatus == 2"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #6ABCF8;margin:auto;color:#6ABCF8;font-size:10px;"
            >
              部分出库
            </div>
            <div
              v-if="scope.row.outStorageStatus == 3"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #ccc;margin:auto;color:#ccc;font-size:10px;"
            >
              作废
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="button5" @click="detail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryInfo.pageNum"
          :page-size="queryInfo.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  refundGoodsList,
  refundGoodsListTotalNum,
  repositoryList,
  Shop_handlerList,
  getRefundGoodsStatistic
} from "../api";
export default {
  data() {
    return {
      value: "",
      options: [],
      tableData: [],
      total: 0,
      queryInfo: {
        pageNum: 1,
        pageSize: 10
      },
      userList: "",
      outStorageStatusList: [
        { value: "", name: "退货状态" },
        { value: 0, name: "未出库" },
        { value: 1, name: "已出库" },
        { value: 2, name: "部分出库" }
      ],
      outStorageStatus: "",
      isDestroyList: [
        { value: "", name: "显示作废" },
        { value: 0, name: "显示" },
        { value: 1, name: "不显示" }
      ],
      isDestroy: "",
      totalRefoundMoney: 0,
      shopStoreId: "",
      repositoryList: [],
      repository: "",
      handlerList: [],
      shopWorkerUserId: "",
      synthesisOrderTypeList: [
        { value: "", name: "全部排序" },
        { value: 0, name: "业务日期" },
        { value: 1, name: "单号" },
        { value: 2, name: "供应商名称" },
        { value: 3, name: "金额" }
      ],
      synthesisOrderType: "",
      synthesisSearch: "",
      startDate: "",
      endDate: "",
      confirmSearch: "",
      dataTime: "",
      str: "",
      loading: false
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getRefundGoodsList();
    this.getRepositoryList();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 清楚搜索内容
    deleteSearch() {
      this.synthesisOrderType = "";
      this.repository = "";
      this.shopWorkerUserId = "";
      this.outStorageStatus = "";
      this.isDestroy = "";
      this.synthesisSearch = "";
      this.dataTime = "";
      this.startDate = "";
      this.endDate = "";
      this.getRefundGoodsList();
    },
    // 搜索
    search() {
      this.queryInfo.pageNum = 1;
      this.confirmSearch = 1;
      this.getRefundGoodsList(
        this.synthesisSearch.trim(),
        this.synthesisOrderType,
        this.startDate,
        this.endDate,
        this.repository,
        this.shopWorkerUserId,
        this.isDestroy,
        this.outStorageStatus
      );
    },
    synthesisOrderTypeChange(val) {
      this.getRefundGoodsList(
        this.synthesisSearch.trim(),
        val,
        this.startDate,
        this.endDate,
        this.repository,
        this.shopWorkerUserId,
        this.isDestroy,
        this.outStorageStatus
      );
    },
    // 详情
    detail(item) {
      console.log(item);
      this.$router.push({
        path: "/invoicingFather/goodsPurchaseReturnDetail",
        query: { orderId: item.orderId, isDestroy: item.isDestroy }
      });
    },
    // 获取总金额
    getTotalRefoundMoney(
      synthesisSearch,
      synthesisOrderType,
      startDate,
      endDate,
      repositoryId,
      handlerId,
      isDestroy,
      outStorageStatus
    ) {
      getRefundGoodsStatistic({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999,
        synthesisSearch: synthesisSearch,
        synthesisOrderType: synthesisOrderType,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        handlerId: handlerId,
        isDestroy: isDestroy,
        outStorageStatus: outStorageStatus
      }).then(res => {
        if (res.code == 1) {
          this.totalRefoundMoney = res.data.money;
        }
      });
    },
    // 获取进货退货单列表
    getRefundGoodsList(
      synthesisSearch,
      synthesisOrderType,
      startDate,
      endDate,
      repositoryId,
      handlerId,
      isDestroy,
      outStorageStatus
    ) {
      this.loading = true;
      refundGoodsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        synthesisSearch: synthesisSearch,
        synthesisOrderType: synthesisOrderType,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repositoryId,
        handlerId: handlerId,
        isDestroy: isDestroy,
        outStorageStatus: outStorageStatus
      }).then(res => {
        this.loading = false;
        this.getTotalRefoundMoney(
          this.synthesisSearch.trim(),
          this.synthesisOrderType,
          this.startDate,
          this.endDate,
          this.repository,
          this.shopWorkerUserId,
          this.isDestroy,
          this.outStorageStatus
        );
        refundGoodsListTotalNum({
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          isManager: 1,
          // pageNo: this.queryInfo.pageNum,
          // row: this.queryInfo.pageSize,
          synthesisSearch: synthesisSearch,
          synthesisOrderType: synthesisOrderType,
          startDate: startDate,
          endDate: endDate,
          repositoryId: repositoryId,
          handlerId: handlerId,
          isDestroy: isDestroy,
          outStorageStatus: outStorageStatus
        }).then(res => {
          if (res.code == 1) {
            this.total = res.data.totalNum;
            this.shopStoreId = res.data.requestVo.shopStoreId;
          }
        });
        if (res.code == 1) {
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].accountRefundPayable = this.tableData[
              i
            ].accountRefundPayable.toFixed(2);
            if (this.tableData[i].productJson.length >= 1) {
              this.str = this.tableData[i].productJson
                .map(item => item.goodsName)
                .join(",");
              this.tableData[i].goodsName = this.str;
            }
            if (this.tableData[i].isDestroy == 1) {
              this.tableData[i].outStorageStatus = 3;
            }
          }
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 分页
    handleCurrentChange(newVal) {
      this.queryInfo.pageNum = newVal;
      if (this.confirmSearch == 1) {
        this.getRefundGoodsList(
          this.synthesisSearch.trim(),
          this.synthesisOrderType,
          this.startDate,
          this.endDate,
          this.repository,
          this.shopWorkerUserId,
          this.isDestroy,
          this.outStorageStatus
        );
      } else {
        this.getRefundGoodsList();
      }
    },
    handleSizeChange(newVal) {
      this.queryInfo.pageSize = newVal;
      this.getRefundGoodsList();
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
        shopStoreId: this.shopStoreId
      }).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryList.unshift({
            repositoryName: "出库仓库",
            repositoryId: ""
          });
          this.Shop_handlerList();
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      }).then(res => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.handlerList.unshift({
            fullName: "全部经手人",
            shopWorkerUserId: ""
          });
        }
      });
    },
    // 选择业务时期
    dataTimeChoose() {
      console.log(this.dataTime);
      this.startDate = this.dataTime[0];
      this.endDate = this.dataTime[1];
    }
  }
};
</script>

<style scoped>
.content {
  position: absolute;
  top: 160px;
  width: calc(100vw - 217px);
  box-sizing: border-box;
  padding: 25px;
}
.searchGroup {
  margin-top: 10px;
}
.searchGroup .el-select {
  width: 180px;
}
.refundMoney {
  width: calc(100vw - 250px);
  height: 90px;
  background-color: #f8f8f8;
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 20px;
}
.totalMoney {
  box-sizing: border-box;
  padding-bottom: 10px;
}
::v-deep .el-range-editor.el-input__inner {
  position: relative;
  top: 5px;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style>
/* .el-table th {
    background-color: #F2F3F2;
} */
/* .el-input__inner {
    height: 32px!important;
    line-height: 32px!important;
} */
/* .el-input__icon {
    line-height: 32px;
}
.el-date-editor .el-range__icon {
    padding-left: 6px;
    box-sizing: border-box;
}
.el-date-editor .el-range__icon {
    padding: 0;

} */
</style>



// WEBPACK FOOTER //
// src/components/page/goodsPurchaseReturn.vue